import { IconButton, Menu, Skeleton, TableCell, TableRow } from "@mui/material";
import { KeyDriveBodyMin } from "../../Fonts/Body/KeyDriveBodyMin";
import { KeyDriveAvatar } from "../../Avatar/KeyDriveAvatar";
import { AvatarStyleTypeBuilder, UserPicture } from "../../../UserPicture/UserPicture";
import { Delete, Edit, VerticalAlignBottom } from "@mui/icons-material";
import { UserPermission } from "../../../../model/UserModel";
import { KeyDriveChip } from "../../Tags/KeyDriveChip";
import KeydriveMenu, { IKeydriveMenuTable } from "../../KeydriveMenu/KeydriveMenu";
import { StatePrivilegesTypes } from "../../../../pages/WorkSpace/Permissions/WorkSpacePermissions";
import { useTranslation } from "react-i18next";
import usePrivilegeName from "../../../../functions/hooks/usePrivilegeName";

interface IUserRowDefault {
    loading: boolean;
    user: UserPermission;
    setPrivilegesState?: (set: { state: StatePrivilegesTypes, id: string, permissionType: number }) => void;
    ownerId: string;
    hasFolderChild: boolean;
}

function UserRowDefault({
    loading,
    user,
    setPrivilegesState,
    ownerId,
    hasFolderChild
}: IUserRowDefault) {

    const { t } = useTranslation();
    const { privilegeName } = usePrivilegeName(user?.permissionType!);

    function renderAllChips() {
        if (ownerId != undefined) {
            if (ownerId == user.userId) {
                return (
                    <>                
                        <KeyDriveChip 
                            text={privilegeName}
                        /> / <KeyDriveChip 
                                text={t("Privileges.Owner")}
                            />
                    </>
                )
            }
        }

        return (
            <>
                <KeyDriveChip
                    text={privilegeName}
                /> 
            </>
        )
    }

    return (
        <TableRow style={{ display: 'table-row', border: "1px solid rgba(224, 224, 224, 1)" }}>
            {
                <TableCell sx={{ paddingRight: '8px', paddingLeft: "8px", paddingBottom: 0, paddingTop: 0, border: "none" }}>

                    {(!loading) ?
                        <>
                            { !hasFolderChild && (
                                <IconButton
                                    onClick={() => {}}
                                >
                                    <KeydriveMenu<IKeydriveMenuTable> 
                                        options={[
                                            {
                                                icon: <Edit />,
                                                onClick: () => {
                                                    setPrivilegesState!({ state: "editing user", id: user.userId!, permissionType: user.permissionType });
                                                },
                                                text: "Editar"
                                            },
                                            {
                                                icon: <Delete />,
                                                onClick: () => {
                                                    setPrivilegesState!({ state: "deleting permission", id: user.userId!, permissionType: user.permissionType });
                                                },
                                                text: "Deletar"
                                            },
                                        ]}
                                    />
                                </IconButton> 
                            )}                       
                        </>
                        :
                        <Skeleton animation="wave" variant="circular" width={24} height={24} />
                    }
                </TableCell>
            }
            <TableCell sx={{ display: 'flex', alignItems: "center", gap: 1, paddingX: '8px', paddingY: "18px", border: "none" }}>
                {(!loading) ?
                    <UserPicture 
                        style={AvatarStyleTypeBuilder.column}
                        source={user?.picture!}
                        username={user?.userName}
                    /> :
                    <Skeleton animation="wave" variant="circular" width={26} height={26} />
                }

                {(!loading) ?
                    <KeyDriveBodyMin
                        color="#2D2D2D"
                        needBold
                        needEllipses={false}
                        text={user?.userName!}
                    /> :
                    <Skeleton width='100%' />
                }
            </TableCell>
            <TableCell sx={{ paddingX: '8px', paddingY: "16px", border: "none" }}>
                {(!loading) ?
                    <KeyDriveBodyMin
                        color="#2D2D2D"
                        needBold
                        needEllipses={false}
                        text={user?.login!}
                    /> :
                    <Skeleton />
                }
            </TableCell>
            {
                <TableCell sx={{ paddingX: '8px', paddingY: "16px", border: "none" }}>
                    {(!loading) ?
                        <KeyDriveBodyMin
                            color="#2D2D2D"
                            needBold
                            needEllipses={false}
                            text={user?.phone! ?? "(00) 0000-0000"}
                        /> :
                        <Skeleton />
                    }
                </TableCell>
            }
            {
                <TableCell key={user.userId} sx={{ paddingX: '8px', paddingY: "16px", border: "none",display: "flex", justifyContent: "center" }}>
                    {(!loading) ?
                        renderAllChips()
                        : 
                        <Skeleton />
                    }
                </TableCell>
            }
        </TableRow>
    )
}

export default UserRowDefault;